import dynamic from "next/dynamic";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

const VideoModal = dynamic(() => import("./VideoModal"));

export default function VideoHighlight({
  data,
  className,
  toggleVideo,
  isVideoModalVisible,
  videoId,
}) {
  // Elements
  const PlayButton = ({ id }) => {
    return (
      <button
        className="play-btn"
        aria-label="Play Video Button"
        onClick={(e) => {
          let id = e.target.closest(".play-btn").id;
          toggleVideo(id);
        }}
        id={id}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 80 80"
          width="80"
          height="80"
        >
          <g fill="none">
            <circle
              cx="40"
              cy="40"
              r="38"
              fill="#000"
              fillOpacity=".25"
              stroke="#FFF"
              strokeWidth="4"
            ></circle>
            <path
              fill="#FFF"
              d="M32 55.73c0 1.696 1.978 2.622 3.28 1.536l18.876-15.73c.96-.8.96-2.273 0-3.072L35.28 22.734c-1.302-1.086-3.28-.16-3.28 1.536v31.46z"
            ></path>
          </g>
        </svg>
      </button>
    );
  };
  const Video = ({ data }) => {
    return (
      <video autoPlay loop poster={data.preview} preload="auto" playsInline>
        <source src={data.thumbnail} type="video/mp4" />
      </video>
    );
  };

  const VideoHighlight = () => {
    return (
      <div
        className={`video-highlight light-shadow md:w-100 ${className}`}
        style={{ height: "auto" }}
      >
        <div id="videoUtube"></div>
        <a className="video-timg">
          <Video data={data} />
          <PlayButton id={data.id} />
        </a>
        <style jsx>{`
          @media (max-width: ${viewport.tablet.sm}) {
            .video-highlight .video-timg::after {
              display: none;
              content: "";
            }
          }
        `}</style>
      </div>
    );
  };
  return (
    <>
      {isVideoModalVisible ? (
        <VideoModal toggleVideo={toggleVideo} videoId={videoId} />
      ) : (
        ""
      )}
      <VideoHighlight />
    </>
  );
}
